<template>
  <div class="page-container">
    <div class="page-content">
      <div
        v-if="loading"
        class="overlay-modal d-flex align-items-center justify-content-center"
      >
        <div>
          <div class="d-flex justify-content-center mb-2">
            <b-spinner label="Loading..."></b-spinner>
          </div>
          <div class="d-flex align-items-center">
            <strong>Carregando</strong>
          </div>
        </div>
      </div>
      <!-- HEADER idêntico -->
      <div class="page-header">
        <div class="d-flex align-items-center mb-3 w-100">
          <h1 class="text-white mb-0">
            <i class="mdi mdi-file-alert"></i>
            Sinistros
          </h1>

          <div class="ml-auto">
            <div class="btn-group">
              <button class="btn btn-outline-white" v-b-modal.modal-filter>
                <i class="fa fa-filter"></i>
                <span class="d-none d-md-inline-block ml-2">Filtros</span>
              </button>
              <button
                class="btn btn-outline-white"
                title="Limpar Filtros"
                @click="cleanFilter"
                :disabled="!areFiltersActive"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Alertas -->
      <div v-if="alertMessage" class="col-12">
        <div class="alert-custom alert-danger-custom">{{ alertMessage }}</div>
      </div>

      <!-- BODY -->
      <div class="page-body">
        <div class="card bg-light-gray">
          <div class="card-body pt-1">
            <!-- TABELA no estilo table-v3 -->
            <div class="table-responsive">
              <table
                role="table"
                aria-busy="false"
                aria-colcount="8"
                class="table-v3"
              >
                <thead role="rowgroup">
                  <tr>
                    <th class="nowrap">Apólice</th>
                    <th class="nowrap">Descrição</th>
                    <th class="nowrap">Tipo de Seguro</th>
                    <th class="nowrap text-center">Seguradora</th>
                    <th class="nowrap">Tomador</th>
                    <th class="nowrap">Segurado</th>
                    <th class="nowrap">Usuário</th>
                    <th class="nowrap">Data de criação</th>
                    <th class="nowrap">Ações</th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                  <tr v-for="item in paginatedItems" :key="item.id">
                    <td data-column-title="Apólice">{{ item.number }}</td>
                    <td
                      data-column-title="Descrição"
                      :title="item.description"
                      style="white-space: normal"
                    >
                      {{ truncateText(item.description) }}
                    </td>
                    <td data-column-title="Tipo de Seguro">
                      {{ item.insurance_type_id }}
                    </td>
                    <td data-column-title="Seguradora" class="text-center">
                      {{ item.insurer_selected }}
                    </td>
                    <td data-column-title="Tomador">
                      {{ truncateText(item.policy_holder_name)}}
                    </td>
                    <td data-column-title="Segurado">
                      {{ truncateText(item.insured_name) }}
                    </td>
                    <td data-column-title="Usuário">
                      {{ truncateText(item.user_name) }}
                    </td>
                    <td data-column-title="Data de criação">
                      {{ item.created_at }}
                    </td>
                    <td data-column-title="Ações" class="text-center">
                      <button
                        class="btn btn-action"
                        @click="redirect('show-claim', { claimId: item.id })"
                        v-b-tooltip.hover
                        title="Visualizar Sinistro"
                      >
                        <i class="fas fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <nav aria-label="Paginação">
          <b-pagination
            v-model="currentPage"
            :total-rows="items.length"
            :per-page="perPage"
          ></b-pagination>
        </nav>
        <b-modal id="modal-filter" title="Filtrar sinistros" size="lg" centered hide-footer>
            <b-form @submit.prevent="applyFilters">
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group
                    label="Tomador "
                    label-for="fh-policy-holder"
                  >
                    <b-form-input
                      id="fh-policy-holder"
                      v-model="filters.policy_holder_name"
                      placeholder="Digite o tomador"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group
                    label="Segurado"
                    label-for="fh-insured-name"
                  >
                    <b-form-input
                      id="fh-insured-name"
                      v-model="filters.insured_name"
                      placeholder="Digite o segurado"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group
                    label="Número da apólice"
                    label-for="fh-number"
                  >
                    <b-form-input
                      id="fh-number"
                      v-model="filters.number"
                      placeholder="Digite o número da apólice"
                      autocomplete="off"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <div class="d-flex justify-content-end">
                <b-button variant="outline-secondary" class="mr-2" @click="$bvModal.hide('modal-filter')">
                  Cancelar
                </b-button>
                <b-button type="submit" variant="primary">
                  Aplicar
                </b-button>
              </div>
            </b-form>
          </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import policyService from "@/services/policy";
import dateFormatter from "@/mixins/dateFormatter";
import translateInsuranceTypes from "@/enums/translate/insuranceTypes";
import commomsHelper from "@/mixins/commomsHelper";

export default {
  name: "list-claims",
  mixins: [dateFormatter, commomsHelper],
  data: () => ({
    perPage: 10,
    currentPage: 1,
    items: [],
    loading: false,
    translateInsuranceTypes: translateInsuranceTypes,
    filters: {
      policy_holder_name: "",
      insured_name: "",
      number: "",
    },
  }),
  created() {
    this.getClaims();
  },
  computed: {
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.items.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.items.length / this.perPage) || 1;
    },

    pages() {
      const total = this.totalPages;
      if (total <= 3) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      if (this.currentPage === 1) {
        return [1, 2, 3];
      }
      if (this.currentPage === total) {
        return [total - 2, total - 1, total];
      }
      return [this.currentPage - 1, this.currentPage, this.currentPage + 1];
    },
    areFiltersActive() {
      return Object.values(this.filters).some(v => String(v || "") !== "");
    },
  },
  methods: {
    getClaims(params) {
      this.loading = true;
      policyService
        .getClaims(params)
        .then((response) => {
          if (response.data.error) {
            this.alertMessage = response.data.message;
            return;
          }
          this.formatList(response.data);
        })
        .catch(() => {
          this.alertMessage = "Não foi possível recuperar os sinistros.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatList(data) {
      this.items = data.map((element) => ({
        id: element.id,
        number: element.policy.number,
        policy_holder_name: element.policy.policy_holder_name,
        insurance_type_id: this.getEnumKeyByEnumValue(
          this.translateInsuranceTypes,
          element.policy.insurance_type_id
        ),
        description: element.description,
        insurer_selected: element.policy.insurer_selected,
        insured_name: element.policy.insured_name,
        user_name: element.user ? element.user.name : "",
        created_at: this.formatDateTimeLocal(element.created_at),
      }));
    },
    redirect(routeName, params = null) {
      this.$router.push({ name: routeName, params: params });
    },
    truncateText(text, maxChar = 28) {
      return text.length > maxChar ? `${text.substring(0, maxChar)}...` : text;
    },
    applyFilters() {
    this.getClaims({ ...this.filters });
    this.$bvModal.hide("modal-filter");
  },

  cleanFilter() {
    if (!this.areFiltersActive) return;
    this.filters = { policy_holder_name: "", insured_name: "", number: "" };
    this.getClaims();
  },
  },
};
</script>

<style>
</style>
